import React from "react";
import { Modal } from "../../../components/Modal";
import alert from "../../../assets/icons/alert.svg";
import { theme } from "../../../styles/theme";
import { Div } from "../../../styles/Common";
import { Button } from "../../../components/Button";
export const ModalConfirm = ({
  openModal,
  handleClose,
  handleLeave,
}) => {
  return (
    <Modal
      open={openModal}
      onCancel={handleClose}
      align={"center"}
      padding={36}
    >
      <Modal.Header
        icon={alert}
        iconBackground={theme.colors.salmon}
        iconWidth={"24px"}
        iconHeight={"24px"}
        align={"-webkit-center"}
        padding="16px 0 16px 0"
        title={"Are you sure you want to leave the page without savig the last changes?"}
      />
      <Modal.Footer style={{ flexDirection: "column" }}>
        <Div gap="32px" justify="center">
          <Button
            onClick={handleClose}
            border={theme.colors.dark}
            color={theme.colors.dark}
          >
            Go back to editing
          </Button>
          <Button
            onClick={handleLeave}
            background={theme.colors.salmon}
          >
            Yes, leave
          </Button>
        </Div>
      </Modal.Footer>
    </Modal>
  );
};